/** Public customer-facing URL for a vehicle listing. */

export function buildCarPublicPath(car) {
  const id = car?.stockNumber ?? car?.id;
  if (id == null || id === '') return '/inventory';
  return `/cars/${id}`;
}

export function buildCarPublicUrl(car, origin = typeof window !== 'undefined' ? window.location.origin : '') {
  return `${origin}${buildCarPublicPath(car)}`;
}
